function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 12.315C6.912 12.315 5.213 10.617 5.213 8.529C5.213 6.441 6.913 4.74 9 4.74C11.087 4.74 12.787 6.44 12.787 8.527C12.787 10.614 11.087 12.312 9 12.312V12.315ZM9 6.242C7.74 6.242 6.713 7.268 6.713 8.529C6.713 9.79 7.74 10.814 9 10.814C10.26 10.814 11.287 9.789 11.287 8.528C11.287 7.267 10.26 6.24 9 6.24V6.242Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.692 8.69C17.692 3.9 13.792 0 9 0C4.208 0 0.307999 3.9 0.307999 8.69C0.307999 10.592 0.910999 12.398 2.051 13.913L2.054 13.911L2.061 13.926C3.689 15.996 8.339 19.683 8.536 19.838C8.674 19.948 8.838 20.001 9.001 20.001C9.164 20.001 9.328 19.948 9.466 19.839C9.663 19.684 14.313 15.999 15.941 13.927L15.948 13.913L15.95 13.915C17.09 12.399 17.692 10.595 17.692 8.692V8.69ZM9 18.29C7.776 17.3 4.48 14.575 3.244 13.005C2.304 11.755 1.808 10.263 1.808 8.693C1.808 4.727 5.035 1.5 9 1.5C12.965 1.5 16.192 4.726 16.192 8.69C16.192 10.26 15.695 11.752 14.756 13.003C13.52 14.573 10.224 17.297 9 18.288V18.29Z"
});

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.61b70989.svg";
export { ForwardRef as ReactComponent };